import { IAction } from "coral-utility";
import navigationActionTypes, {
  NavigationPayload,
  SetNavigationItemsAction,
} from "./types";

export const getNavigationAction = (): IAction => ({
  type: navigationActionTypes.GET_NAVIGATION_ITEMS,
});

export const getNavigationFailureAction = (): IAction => ({
  type: navigationActionTypes.GET_NAVIGATION_ITEMS_FAILURE,
});

export const setNavigationItemsAction = (
  items: NavigationPayload
): SetNavigationItemsAction => ({
  type: navigationActionTypes.GET_NAVIGATION_ITEMS_SUCCESS,
  payload: items,
});
